var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms px-4 px-sm-6"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }